var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5586,
    cy: 66.5,
    r: 33.5,
    fill: "#EAECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5371 17C65.5371 17 35.6919 17.0156 35.6452 17.0156C24.9154 17.0816 18.2715 24.1416 18.2715 34.9103V56.6608C18.2715 67.4839 24.966 74.5711 35.7891 74.5711C35.7891 74.5711 65.6304 74.5594 65.681 74.5594C76.4108 74.4933 83.0586 67.4295 83.0586 56.6608V34.9103C83.0586 24.0871 76.3603 17 65.5371 17Z",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 57C75 52.5817 71.4183 49 67 49H34",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#513DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4152 28.2469L31.2465 17.4156",
    stroke: "#DB3C9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2473 28.247L20.416 17.4158",
    stroke: "#DB3C9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3197_23608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 25,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.29 32C70.29 29.7909 68.4992 28 66.29 28V28",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6672 40.8069C71.1454 39.137 69.5988 38 67.8493 38H64.7308",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 25.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#513DD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3197_23608"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 25,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.0726ddfb57555bb49770c83f9153b931.svg";
export { ForwardRef as ReactComponent };